export const NOTIFICTION_MESSAGES = {
    SOMETHING_WENT_WRONG: 'Something went wrong, please try again!',
}
